import { render, staticRenderFns } from "./SelectProductDialog.vue?vue&type=template&id=2d204a8e&"
import script from "./SelectProductDialog.vue?vue&type=script&lang=js&"
export * from "./SelectProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductDialog.vue?vue&type=style&index=0&id=2d204a8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports